enum QueryMode {
    "CSAEarliestArrival",
    "CSAProfile",
    "Dijkstra",
}

export default QueryMode;
